(function () {
    'use strict';

    a3_cabin_reports.controller('FlightCourseCtrl', FlightCourseCtrl);
    /**
     * @memberof CabinReports
     * @ngdoc controller
     * @name FlightCourseCtrl
     * @description 
     *
     * @ngInject
     */
    function FlightCourseCtrl($route, $filter, $timeout, FlightSessionFactory, CrewRouteFactory, FlightFactory, GroundDutyFactory, CourseFactory, $scope, $location, $routeParams) {
        $scope.gotoCourse = gotoCourse;
        $scope.gotoCrewRoute = gotoCrewRoute;
        $scope.gotoFlight = gotoFlight;
        $scope.stickySelectedTrainee = stickySelectedTrainee;
        $scope.toggleView = toggleView;

        $scope.refreshCourse = refresh;
        $scope.courseTrainees = [];

        var courseId = Number($routeParams.courseId);
        var dutyNo = Number($routeParams.dutyNo);
        var dutyDay = Number($routeParams.dutyDay);
        $scope.viewFromFlight = Number($routeParams.flightId);

        var crewRouteDuty = CrewRouteFactory.getCrewRouteFromStorage(dutyNo, dutyDay);
        
        var date = $routeParams.date;
        crewRouteDuty.date = date;
        
        var crewRouteCourse = crewRouteDuty.Courses.find(x => x.CourseId == courseId && new moment(x.Date).isSame(date));

        $scope.isEdit = false;
        $scope.loading = false;
        $scope.refreshSuccess = true; //show refresh icon


        if (!crewRouteDuty) {
            // go to dashboard if no groundDuty
            $location.path("/");
        } 
        else 
        {
            $scope.flights = FlightFactory.getFlightsByDutyNo(dutyNo, dutyDay);
            $scope.currentFlight = $scope.flights.filter(f => f.FlightId == Number($routeParams.flightId));

            var crewRouteTrainees = FlightSessionFactory.getCrewRouteFlightTrainees(dutyNo, dutyDay, crewRouteCourse.TrainingFlightIds)

            //Get Crew Route's course
            CourseFactory.getCourseFromStorage(courseId, function (savedCourse) {
                var dutyCourse = savedCourse;
                $scope.dutyCourse = dutyCourse;
                initCourse(false);
            });
            $scope.crewRouteDuty = crewRouteDuty;
        }


        function initCourse(afterRefresh) {
            var courseId = $scope.dutyCourse.Id;
            FlightSessionFactory.getSession(courseId, date, dutyNo, dutyDay, crewRouteCourse.TrainingFlightIds, afterRefresh, function (course) {
                if (course && !course.HasLimitedInfo) {
                    $scope.availableCourse = true;
                    
                    $scope.selectedPhase = course.selectedPhase;
                    $scope.trainees = course.CourseTrainees;
                    course.SequenceWarning = false;
                }

                $scope.course = course;

                manageCourseStatus($scope.dutyCourse, course, afterRefresh);
                toggleView('History'); //default

                if ($scope.trainees) {
                    stickySelectedTrainee();
                    //Check for status change (new trainees found on a submitted session (reset) || failed certificate trainees want to retake the test)
                    if (afterRefresh && $scope.isCourseComplete && $scope.trainees.length) {
                        CrewRouteFactory.setCoursePending(dutyNo, dutyDay, courseId, date);
                        $scope.isCourseComplete = false;
                        $route.reload();
                    }
                }

                $scope.reload = false;
                $timeout(function () {
                    $scope.reload = true;
                }, 100);

            });
        }
        
        function gotoCourse(course) {
            $location.path('/course/' + course.Id + '/' + groundDuty.DutyDateS + "/" + groundDuty.Id);
        }

        function gotoCrewRoute(){
            $location.path('/crewRoute/'+ dutyNo + '/' + dutyDay);
        }

        function gotoFlight(){
            var flightId = Number($routeParams.flightId)
            $location.path('/flightinfo/' + flightId);
        }

        function refresh() {
            $scope.loading = true;

            if($scope.isOffline){
                $timeout(function () {
                    $scope.loading = false;
                }, 100);
                $scope.refreshSuccess = false;
                $scope.availableCourseInfo = false;
                $scope.refreshErrorMsg = "Online mode is required in order to get course. Please connect to the internet and try again.";
            }
            else{
                CourseFactory.updateFlightCourseInfo(crewRouteCourse, date, dutyNo, dutyDay, function () {
                    $scope.loading = false;
                    $scope.refreshSuccess = true;
                    $scope.availableCourseInfo = true;
    
                    initCourse(true);
                    $scope.reload = false;
                    $timeout(function () {
                        $scope.reload = true;
                    }, 100);
    
                },
                    function () {
                        $scope.loading = false;
                        $scope.refreshSuccess = false;
                        $scope.availableCourseInfo = false;
                        $scope.refreshErrorMsg = "Something went wrong! Please Try again.";
                    },
                    function (error) {
                        console.log(error);
                        $scope.loading = false;
                        $scope.refreshSuccess = false;
                        $scope.availableCourseInfo = false;

                        $scope.refreshErrorMsg = "Oops! Something went wrong!";

                        //null exception!
                        // if (error.data.errorMessage) {
                        //     $scope.refreshErrorMsg = error.data.errorMessage;
                        // }
                    }
                )
            }
        }

        function manageCourseStatus(dutyCourse, course, afterRefresh) {
            // COMPLETED : has been submitted
            var isCourseComplete = crewRouteCourse.Status == "Completed";

            // NEEDS SUBMIT : 1 hour has passed since the end of the course
            var now = moment.utc();
            if (!dutyCourse.IsCompleted) {
                var needsSubmit = false;
                var fetched = moment.utc(crewRouteDuty.DutyEnd);
                var duration = moment.duration(now.diff(fetched)).asHours();
                if (duration > 1) {
                    needsSubmit = true;
                }
            }
           
            // LIMITED : no info available
            var isCourseLimited = !course || course.HasLimitedInfo || (course.HasLimitedSession && !afterRefresh);

            // OUTDATED : NeedsRefresh || 18 hours since last refresh
            var isCourseOutdated = false;
            if (course && course.FetchedTime) {
                var now = moment.utc();
                var fetched = moment.utc(course.FetchedTime);
                var duration = moment.duration(now.diff(fetched)).asHours();

                if (duration > 18 || course.NeedsRefresh) {
                    isCourseOutdated = true;
                }
            }

            var hasAdditionalTrainingRequest = false;
            if (course.SubmittedSessions && course.SubmittedSessions.length > 0) {
                 if (course.SubmittedSessions.map(x => x.TraineesSessions.filter(y => y.UnderAdditionalTraining == true).length > 0)){
                    hasAdditionalTrainingRequest = true;
                    course.hasAdditionalTrainingRequest = true;
                };
            }

            var isUnderAdditionalTraining = false;
            if (course.SubmittedSessions && course.SubmittedSessions.length > 0) {
                if (course.SubmittedSessions.map(x => x.TraineesSessions.find(y => y.UnderAdditionalTraining == true))){
                    isUnderAdditionalTraining = true;
                    course.isUnderAdditionalTraining = true;
                };
            }

            $scope.headerMsg = "Refresh Course";
            if(isCourseLimited) $scope.headerMsg = "Fetch Course";

            $scope.hasPendingTraining = !isCourseComplete;
            $scope.hasUnsetTraining = needsSubmit;
            $scope.isCourseLimited = isCourseLimited;
            $scope.isCourseComplete = isCourseComplete;
            $scope.isCourseOutdated = isCourseOutdated;
            $scope.hasAdditionalTrainingRequest = hasAdditionalTrainingRequest;
            $scope.hasNotifications = isCourseLimited || isCourseOutdated || isCourseComplete;
        }

        function stickySelectedTrainee(){
            if($scope.trainees && $scope.trainees.filter(x => !x.Session.Absent).length){
                if($scope.trainees.filter(x => !x.Session.Absent).find(x => x.Session.selected)){
                    $scope.selectedTrainee = $scope.trainees.filter(x => !x.Session.Absent).find(x => x.Session.selected);
                }
                else{
                    $scope.selectedTrainee = $scope.trainees.filter(x => !x.Session.Absent)[0];
                }
            }
            else{
                $scope.selectedTrainee = null;
            }
            if($scope.selectedTrainee) $scope.selectedTraineeBadge = {CrewId:$scope.selectedTrainee.CrewId};
        }

        function toggleView(mode){
            $scope.viewMode = mode;
        }
    }
})();
